import { useQuery } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { QueryFunction } from '@frontend/api';

import { getContactQueryKey, type ContactQueryKey } from './keys';
import type { ContactData, UseContactParams } from './types';

export const useContact: QueryFunction<
  ContactData,
  [UseContactParams],
  ContactQueryKey
> = (params, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  const queryKey = getContactQueryKey(params);
  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) =>
      request(`/contacts/${params.contactId}`, {
        init: {
          method: 'GET',
          signal,
        },
      }),
  });
};
